export default __webpack_public_path__ + "39644be26afc5e2246687c962a98a825.png";